import { getAPIURL } from "./config";

const parseSubstitutionError = async (response, fallbackMessage) => {
  const text = await response.text();
  let message = fallbackMessage;
  try {
    const err = JSON.parse(text);
    if (Array.isArray(err.detail)) {
      message = err.detail
        .map((d) => d.msg || JSON.stringify(d))
        .join("; ");
    } else if (err.detail) {
      message = String(err.detail);
    } else if (err.message) {
      message = err.message;
    }
  } catch {
    if (text) message += `. ${text}`;
  }
  throw new Error(message);
};

/**
 * Список замещений с пагинацией и фильтрацией
 * GET /substitutions/
 * @param {{
 *   page?: number,
 *   page_size?: number,
 *   include_inactive?: boolean,
 *   absent_user_id?: number,
 *   substitute_user_id?: number,
 * }} [params]
 */
export const getSubstitutions = async (params = {}) => {
  const searchParams = new URLSearchParams();
  searchParams.set("page", String(params.page ?? 1));
  searchParams.set("page_size", String(params.page_size ?? 50));
  searchParams.set(
    "include_inactive",
    String(params.include_inactive ?? false)
  );
  if (params.absent_user_id != null) {
    searchParams.set("absent_user_id", String(params.absent_user_id));
  }
  if (params.substitute_user_id != null) {
    searchParams.set("substitute_user_id", String(params.substitute_user_id));
  }

  const response = await fetch(
    `${getAPIURL()}substitutions/?${searchParams.toString()}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    }
  );

  if (!response.ok) {
    await parseSubstitutionError(
      response,
      `Ошибка при загрузке замещений: ${response.status}`
    );
  }

  return response.json();
};

/**
 * Создание замещения
 * POST /substitutions/
 * @param {{
 *   absent_user_id: number,
 *   substitute_user_id: number,
 *   start_date: string,
 *   end_date: string,
 *   reason: string,
 *   delegate_approvals: boolean,
 *   delegate_roles: boolean,
 *   comment?: string,
 * }} body
 */
export const createSubstitution = async (body) => {
  const response = await fetch(`${getAPIURL()}substitutions/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    await parseSubstitutionError(
      response,
      `Ошибка при создании замещения: ${response.status}`
    );
  }

  return response.json();
};
